import { render, staticRenderFns } from "./viewComplaints.vue?vue&type=template&id=7f61b560&scoped=true"
import script from "./viewComplaints.vue?vue&type=script&lang=js"
export * from "./viewComplaints.vue?vue&type=script&lang=js"
import style0 from "./viewComplaints.vue?vue&type=style&index=0&id=7f61b560&prod&lang=css"
import style1 from "./viewComplaints.vue?vue&type=style&index=1&id=7f61b560&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f61b560",
  null
  
)

export default component.exports